import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { CheckCircle2 } from 'lucide-react';

/** Step 2 del carico multiplo (modalità quantità): input pezzi per consumabili. */
export const BulkStepQuantita = ({ template, quantita, setQuantita }) => (
  <div className="space-y-4 py-2">
    <div className="p-3 bg-muted border border-border text-sm">
      <div className="font-medium">{template.descrizione}</div>
      <div className="text-xs text-muted-foreground">{[template.marca, template.modello, template.categoria].filter(Boolean).join(' · ') || 'Consumabile'}</div>
    </div>
    <div>
      <Label className="text-xs font-mono uppercase">Quantità da caricare *</Label>
      <Input
        type="number"
        min="1"
        step="1"
        value={quantita}
        onChange={(e) => setQuantita(e.target.value)}
        placeholder="Es. 10"
        className="rounded-none font-mono text-2xl h-14 text-center"
        autoFocus
        data-testid="bulk-quantita-input"
      />
    </div>
    <div className="flex items-center gap-2 text-xs text-muted-foreground">
      <CheckCircle2 className="h-4 w-4 text-emerald-500" />
      Se l&apos;articolo esiste già in magazzino, la quantità verrà sommata a quella attuale.
    </div>
  </div>
);
